import React from "react";
import { ArrowUpRight } from "lucide-react";
import { SERVICES, QUICK_SERVICES } from "../lib/constants";

export default function Services() {
  const jumpToQuote = (serviceTitle) => {
    const el = document.getElementById("quote");
    if (!el) return;
    // pre-fill by dispatching a custom event
    window.dispatchEvent(
      new CustomEvent("prefill-service", { detail: serviceTitle })
    );
    el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section
      id="services"
      data-testid="services-section"
      className="py-24 md:py-32 border-t border-[#332C27] bg-[#14110F]"
    >
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14 reveal">
          <div className="max-w-2xl">
            <div className="text-[11px] uppercase tracking-[0.28em] text-[#F5A623] font-bold mb-4">
              / 01 — What we fix
            </div>
            <h2
              data-testid="services-heading"
              className="font-display text-4xl md:text-5xl lg:text-6xl text-[#F9FAFB] font-semibold uppercase tracking-tight"
            >
              A true handyman —
              <br />
              <span className="text-[#F5A623]">not a one-trick crew.</span>
            </h2>
          </div>
          <p className="text-[#A19D98] max-w-md text-base leading-relaxed">
            If it screws, seals, hangs or leaks, odds are we've fixed one this
            week. Below are our most-booked services — tap one to start a
            quote.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-12 gap-5 md:gap-6">
          {SERVICES.map((s, i) => (
            <button
              key={s.id}
              data-testid={`service-card-${s.id}`}
              onClick={() => jumpToQuote(s.title)}
              className={`reveal group text-left relative overflow-hidden rounded-2xl border border-[#332C27] bg-[#1E1A18] hover:border-[#F5A623]/50 hover:-translate-y-1 hover:shadow-[0_20px_60px_-20px_rgba(245,166,35,0.25)] transition-all duration-300 ${
                i === 0 ? "md:col-span-7 md:row-span-2" : "md:col-span-5"
              }`}
            >
              <div
                className={`relative overflow-hidden ${
                  i === 0 ? "h-72 md:h-96" : "h-48 md:h-56"
                }`}
              >
                <img
                  src={s.image}
                  alt={s.alt || s.title}
                  loading="lazy"
                  className="absolute inset-0 w-full h-full object-cover transition-transform duration-[900ms] ease-out group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#14110F] via-[#14110F]/40 to-transparent" />
                <div className="absolute top-4 left-4 bg-[#F5A623] text-[#14110F] text-[10px] uppercase tracking-[0.22em] font-bold px-2.5 py-1 rounded-full">
                  {s.tag}
                </div>
              </div>
              <div className="p-6 md:p-8 flex items-start justify-between gap-4">
                <div>
                  <h3 className="font-display text-2xl md:text-3xl text-[#F9FAFB] font-semibold tracking-tight">
                    {s.title}
                  </h3>
                  <p className="text-[#A19D98] text-sm md:text-base leading-relaxed mt-2 max-w-md">
                    {s.blurb}
                  </p>
                </div>
                <div className="shrink-0 w-11 h-11 rounded-full border border-[#F5A623]/40 flex items-center justify-center text-[#F5A623] group-hover:bg-[#F5A623] group-hover:text-[#14110F] transition-colors">
                  <ArrowUpRight className="w-5 h-5" />
                </div>
              </div>
            </button>
          ))}
        </div>

        {/* Quick-hit services strip */}
        <div className="mt-14 reveal">
          <div className="text-[11px] uppercase tracking-[0.28em] text-[#F5A623] font-bold mb-5">
            Also on our tool belt
          </div>
          <div
            data-testid="quick-services-list"
            className="flex flex-wrap gap-2.5"
          >
            {QUICK_SERVICES.map((q) => (
              <span
                key={q}
                className="px-4 py-2 rounded-full border border-[#332C27] text-sm text-[#F9FAFB] bg-[#1E1A18]/60 hover:border-[#F5A623]/50 hover:text-[#F5A623] transition-colors"
              >
                {q}
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
